
import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, PawPrint } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useTranslation } from 'react-i18next';

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const subscriptionId = searchParams.get('subscription_id');
  const planType = searchParams.get('plan_type') || 'Premium';

  useEffect(() => {
    console.log('Payment successful for subscription:', subscriptionId);
  }, [subscriptionId]);

  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-foreground">
            {t('payment.success.title')}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-muted-foreground">
            {t('payment.success.thankYou', { planType })}
          </p>
          
          {subscriptionId && (
            <div className="bg-muted p-3 rounded-lg">
              <p className="text-sm text-muted-foreground">{t('payment.success.subscriptionId')}</p>
              <p className="text-sm font-mono">{subscriptionId}</p>
            </div>
          )}
          
          <div className="space-y-2">
            <Link to="/feed" className="block">
              <Button className="w-full bg-primary hover:bg-primary/90">
                <PawPrint className="h-4 w-4 mr-2" />
                {t('payment.success.goToDashboard')}
              </Button>
            </Link>
            <Link to="/subscription" className="block">
              <Button variant="outline" className="w-full">
                {t('payment.success.viewSubscription')}
              </Button>
            </Link>
          </div>
          
          <p className="text-xs text-muted-foreground">
            {t('payment.success.emailConfirmation')}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
